import React from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';

export default function Button({ children, variant = 'primary', className, onClick, href }) {
  const baseStyles = "inline-flex items-center justify-center px-6 py-3 border text-sm font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "border-transparent text-white bg-slate-900 hover:bg-slate-800 focus:ring-slate-900 shadow-sm hover:shadow-md",
    secondary: "border-slate-200 text-slate-700 bg-white hover:bg-slate-50 focus:ring-slate-500 shadow-sm",
    outline: "border-slate-300 text-slate-700 bg-transparent hover:bg-slate-50 focus:ring-slate-500",
    ghost: "border-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-100"
  };

  const Component = href ? motion.a : motion.button;
  const props = href ? { href } : { onClick };

  return (
    <Component
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.98 }}
      className={clsx(baseStyles, variants[variant], className)}
      {...props}
    >
      {children}
    </Component>
  );
}